export default __webpack_public_path__ + "static/emeria-036d15b40524e5dd9bcbd178ef1c4db4.png";